export default __webpack_public_path__ + "static/m-team4-d0e1ddab6941eb972ac4290428454a81.jpg";